import { addLicense } from '@amcharts/amcharts5';

addLicense(process.env.VUE_APP_AMCHARTS5_CHARTS_LICENSE);
addLicense(process.env.VUE_APP_AMCHARTS5_MAPS_LICENSE);
